import { messagesEN } from './lib/intl/en-US';
import { Options } from '@sheerid/jslib';
import { RecursivePartial } from './lib/types/types';

export const programId = '5fa4497854a50c1833a0b291';

export const defaultOptions: RecursivePartial<Options> = {
    restApi: {
        serviceUrl: 'https://services.sheerid.com/',
    },
    logLevel: 'error',
    useFingerprinting: true,
    messagesWithLocale: {
        'en-US': messagesEN,
    },
};
